import ufeApi from 'services/api/ufeApi';
import Empty from 'constants/empty';
import { CHANNELS } from 'constants/Channels';

const path = '/gway/v1/p13n/puwlo/rtco';

function normalizeRtcoRow(row) {
    if (!row) {
        return null;
    }

    const p13n = row.p13n;
    const variationData = row.variationData;

    if (!p13n) {
        return null;
    }

    return {
        context: p13n.context,
        variation: p13n.variation || '',
        promoType: p13n.promoType || '',
        promoCode: p13n.promoCode || null,
        isControl: p13n.isControl,
        isDefault: p13n.isDefault,
        isAbTest: p13n.isAbTest,
        isRtcoEnabled: p13n.isRtcoEnabled,
        isRouge: p13n.isRouge || false,
        biTier: p13n.biTier || '',
        abTestId: p13n.abTestId || '',
        abTestEndDate: p13n.abTestEndDate ?? p13n.endDate ?? null,
        banner: variationData?.banner || null,
        legalText: variationData?.legalText || null,
        disclaimer: variationData?.disclaimer || null,
        modalSubtitle: variationData?.modalSubtitle || null,
        modalEligibility: variationData?.modalEligibility || null
    };
}

function getP13nRtcoData({
    channel, country, language, atgId, contextId
}) {
    const rtcoChannel = channel === CHANNELS.RWD ? CHANNELS.WEB : channel;

    const locale = `${language}-${country}`;
    const queryParams = `?atg_id=${encodeURIComponent(atgId)}&contextId=${encodeURIComponent(contextId)}&channel=${encodeURIComponent(rtcoChannel)}&locale=${encodeURIComponent(locale)}`;
    const url = `${path}${queryParams}`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(({ data = Empty.Array, errorCode }) => {
        if (errorCode) {
            return Promise.reject(data);
        }

        const firstRow = Array.isArray(data) ? data[0] : data;

        return normalizeRtcoRow(firstRow);
    });
}

export default getP13nRtcoData;
